// 图片缩略工具：仅对阿里云 OSS 域名用 x-oss-process 即时裁剪，
// 大幅减小卡片/列表里的图片体积（原本小卡片也在下几 MB 的拍卖原图）。
//
// 安全原则——绝不弄坏图：
//   · 非 OSS 域名(AWS S3 / 外链 / data:)一律原样返回；
//   · 已带 query 参数(可能是签名 URL)一律原样返回，不追加破坏签名；
//   · 已含 x-oss-process 的不重复处理。
//
// 用法: import { thumb } from '../utils/img';  <img src={thumb(url, 400)} />
export function thumb(url, w = 400) {
  if (!url || typeof url !== 'string') return url;
  if (url.startsWith('data:')) return url;
  if (url.includes('?')) return url; // 已带参数(含签名URL)→ 不动
  const isOss = url.includes('.aliyuncs.com/') || /\.oss[.-]/.test(url);
  if (!isOss) return url;
  return `${url}?x-oss-process=image/resize,w_${w}/quality,q_80`;
}

// 大图场景(详情主图)用更大的宽度；缩略卡片用小宽度。
export const thumbCard = (url) => thumb(url, 400);
export const thumbDetail = (url) => thumb(url, 1200);
